import {
  TweenMax,
  Power0,
  Power2,
  TweenLite
} from 'gsap';

import {localizeHTML, localizeImage} from '../../helpers/lang-utils'

var Signal = require('signals');

var Popup = function (id, cbkIframeLoaded) {

  var elPopupBlackLayer = document.getElementById('popup-black-layer');
  var elPopup = document.getElementById(id);
  // var aPopupBgContent = elPopup.querySelectorAll('.popup-bg-content');
  var signal = new Signal.Signal();
  var oTweenClose = {},
    oTweenOpen = {};
  var isOpened = false;

  if (window.DEBUG_WATER_TEST) {
    elPopupBlackLayer.style.display = 'none';
  }

  oTweenOpen.speed = 0.1;
  oTweenClose.speed = 0.1;

  if (id == 'popup-wait') {
    oTweenClose.top = '0';
    oTweenClose.autoAlpha = 0;
    oTweenOpen.autoAlpha = 1;
  } else if (id == 'popup-end') {
    oTweenClose.top = '0';
    oTweenClose.autoAlpha = 0;
    oTweenOpen.autoAlpha = 1;
    oTweenOpen.speed = 1.5;
  } else if (id == 'popup-mission') {
    oTweenClose.top = '43%';
    oTweenClose.speed = 0.7;
    oTweenClose.autoAlpha = 0;
    oTweenOpen.autoAlpha = 1;
    oTweenOpen.top = '42%';
  } else if (id == 'popup-turn-starboard' || id == 'popup-turn-port') {
    oTweenClose.top = '42%';
    oTweenClose.autoAlpha = 0;
    oTweenOpen.autoAlpha = 1;
    oTweenOpen.top = '41%';
  } else {
    oTweenClose.top = '56%';
    oTweenClose.autoAlpha = 0;
    oTweenOpen.autoAlpha = 1;
    oTweenOpen.top = '54%';
    oTweenOpen.speed = 0.3;
  }
  if (id == 'popup-level') {
    oTweenClose.top = '34%';
    oTweenOpen.top = '32%';
    oTweenOpen.speed = 0.2;
  }

  oTweenOpen.ease = Power2.easeOut;
  oTweenClose.ease = Power2.easeOut;

  var oTemp = Object.assign({}, oTweenClose);
  TweenMax.set(elPopup, oTemp);

  var open = function (delay) {
    isOpened = true;

    // console.log(`Popup ${id} open()`);
    resize();

    if (window.DEBUG_WATER_TEST) {
      return;
    }

    // Load iframe
    if (id == 'popup-wait') {
      elPopupBlackLayer.style.display = 'block';
      if (window.DEBUG_WATER_TEST) {
        elPopup.querySelector('iframe').setAttribute('src', 'empty.html');
      } else {
        if (cbkIframeLoaded)
          elPopup.querySelector('iframe').addEventListener('load', cbkIframeLoaded);
        if (window.DEBUG_SHOW_OUTRO_ON_START) {
          elPopup.querySelector('iframe').setAttribute(
            'src',
            window._sf1
              ? localizeHTML('outro_form.html')
              : window._sf2
                ? localizeHTML('outro_one-cta.html') // ? localizeHTML('outro_form2.html')
                : localizeHTML('outro.html') + '?v=6'
          );
          elPopup.querySelector('iframe').style.pointerEvents = 'all'
        } else {
          elPopup.querySelector('iframe').setAttribute(
            'src',
            window._sf2
              ? localizeHTML('intro_form2.html')
              : localizeHTML('intro.html'));
        }
      }
    } else if (id == 'popup-end') {
      if (window.DEBUG_WATER_TEST) {
        elPopup.querySelector('iframe').setAttribute('src', 'empty.html');
      } else {
        if (cbkIframeLoaded)
          elPopup.querySelector('iframe').addEventListener('load', cbkIframeLoaded);
        elPopup.querySelector('iframe').setAttribute(
          'src',
          window._sf1
            ? localizeHTML('outro_form.html')
            : window._sf2
              ? localizeHTML('outro_one-cta.html') // ? localizeHTML('outro_form2.html')
              : window._sfPOS
                ? localizeHTML('outro_form_pos.html')
                : localizeHTML('outro.html') + '?v=6'
        );
      }
      const elBgContent = elPopup.querySelector('.popup-bg-content')
      if (elBgContent) {
        TweenMax.set(elBgContent, {
          opacity: 0,
          // transformOrigin: 'center center',
          // scale: window.innerWidth / 1920,
          // transformStyle: 'preserve-3d',
          y: `${77 * window.innerWidth / 1920}%`,
          x: '-50%',
        });
        TweenMax.to(elBgContent, 0.6, {
          opacity: 1,
          y: `${75 * window.innerWidth / 1920}%`,
          delay: 0.70
        });
      }
      elPopupBlackLayer.style.display = 'none';
    } else if (id == 'popup-turn-starboard') {
      elPopup.addEventListener('click', close);
    } else if (id == 'popup-turn-port') {
      elPopup.addEventListener('click', close);
    }
    oTweenOpen.delay = delay || 0;
    oTweenOpen.onComplete = () => {
      if (id == 'popup-wait') {
        setTimeout(() => {
          elPopupBlackLayer.style.display = 'none';
          signal.dispatch('end_open');
        }, 500);
      } else if (id == 'popup-end') {
        setTimeout(() => {
          elPopupBlackLayer.style.display = 'block';
        }, 1000);
        signal.dispatch('end_open');
      } else {
        signal.dispatch('end_open');
      }
    }
    var oTemp = Object.assign({}, oTweenOpen);
    TweenMax.to(elPopup, oTemp.speed, oTemp);
  }

  var close = function (delay) {
    // console.log(`CLOSE popup ${id}`);

    // if (id === 'popup-end') return;
    if (isOpened) {
      isOpened = false;
      oTweenClose.delay = delay || 0;
      oTweenClose.onComplete = () => {
        signal.dispatch('end_close');
        if (id == 'popup-wait' || id == 'popup-end') {
          var frame = elPopup.querySelector('iframe');
          var frameDoc = frame.contentDocument || frame.contentWindow.document;
          if (frameDoc && frameDoc.documentElement)
            frameDoc.removeChild(frameDoc.documentElement);
          frame.setAttribute('src', '');
          elPopup.style.display = 'none';
        }
      }
    }
    var oTemp = Object.assign({}, oTweenClose);
    TweenMax.to(elPopup, oTemp.speed, oTemp);
  }

  var resize = function () {
    if (id === 'popup-wait') {
        let _popup = document.querySelector('#popup-wait iframe')
        _popup.style.width = `${window.innerWidth}px`;
        _popup.style.height = `${window.innerHeight}px`;
    }
    else if (id === 'popup-end') {
        let _popup = document.querySelector('#popup-end iframe')
        _popup.style.width = `${window.innerWidth}px`;
        _popup.style.height = `${window.innerHeight}px`;
    }

    if (isOpened) {
      // console.log(`Resize popup ${id}`);
      var nScale = document.documentElement.clientHeight / 1080
      if (nScale > 1) nScale = 1

      TweenMax.set(elPopup, {
        transformOrigin: 'center center',
        // scale: window.innerWidth / 1920,
        scale: nScale,
        transformStyle: 'preserve-3d'
      });

      // if (aPopupBgContent && aPopupBgContent.length > 0) {
      // if (id === 'popup-end') {
      //   console.log(`Resize popup ${id} - bg`, aPopupBgContent[0]);
      //   TweenMax.set(aPopupBgContent[0], {
      //     // scale: window.innerWidth / 1920,
      //     y: `${77 * window.innerWidth / 1920}%`,
      //   })
      // }
      // }
    }
  }

  var showBottleType = function (bottleId) {
    for (var i = 1; i < 4; i++) {
      elPopup.querySelector(`.js-catch-${i}`).style.display = i == bottleId ? 'block' : 'none';
    }
  }

  var showLevelType = function (levelId) {
    for (var i = 1; i < 4; i++) {
      elPopup.querySelector(`.js-level-${i}`).style.display = i == levelId ? 'block' : 'none';
    }
  }

  return {
    open,
    close,
    resize,
    signal,
    showBottleType,
    showLevelType,
    elPopup,
    isOpened
  };
}

export {
  Popup as
  default
};
